import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    vehicle_list: []
  },
  mutations: {
    resetState(state) {
      state.vehicle_list = [];
    },
    getVehicleList(state, data) {
      state.vehicle_list = data;
    },
    deleteVehicle(state, item) {
      let index = state.vehicle_list.indexOf(item);
      state.vehicle_list.splice(index, 1);
    }
  },
  actions: {
    async changeStatusVehicle({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessVehicleBack_changeStatusVehicle +
        item.vehicle_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getVehicleDetail({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessVehicleBack_getVehicleDetail +
        item.vehicle_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        return res;
      }
    },
    async editVehicle({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessVehicleBack_editVehicle + item.vehicle_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getVehicleList", res);
        return 2;
      }
    },
    async deleteVehicle({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessVehicleBack_deleteVehicle + item.vehicle_id;

      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("deleteVehicle", item);
        return "No data available";
      }
    },
    async addVehicle({ commit, dispatch, rootState }, form) {
      let url = rootState.api_urls.fetchMessVehicleBack_addVehicle;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("getVehicleList", res);
        return "No data available";
      }
    },
    async getVehicleList({ commit, dispatch, rootState }) {
      let url = rootState.api_urls.fetchMessVehicleBack_getVehicleList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getVehicleList", res);
        return "No data available";
      }
    }
  },
  getters: {}
};
